import { ChangeDetectionStrategy, Component, HostBinding, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Capability } from '@uigy/generated/graphql';
import {
  IotConnectorsComponent,
} from '@uigy/modules/iot-connectors/components/iot-connectors/iot-connectors.component';
import { IotConnectorsModule } from '@uigy/modules/iot-connectors/iot-connectors.module';
import { NessusScansModule } from '@uigy/modules/nessus-scans/nessus-scans.module';
import { OtAgentsComponent } from '@uigy/modules/ot-agents/components/ot-agents/ot-agents.component';
import { SensorsComponent } from '@uigy/modules/sensors/components/sensors/sensors.component';
import { SensorsModule } from '@uigy/modules/sensors/sensors.module';
import { AssetsSettingsModule } from '@uigy/modules/settings/modules/assets/assets-settings.module';
import {
  ProjectFilesComponent,
} from '@uigy/modules/settings/modules/assets/components/project-files/project-files.component';
import {
  PcapPlayerComponent,
} from '@uigy/modules/settings/modules/pcap-player/components/pcap-player/pcap-player.component';
import { PcapPlayerModule } from '@uigy/modules/settings/modules/pcap-player/pcap-player.module';
import { TabsComponent } from '@uigy/shared/components/tabs/tabs.component';
import { DataSourceTabQueryParams, TabGroup } from '@uigy/shared/components/tabs/tabs.enums';
import { Tab, TabConfig } from '@uigy/shared/components/tabs/tabs.interface';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { CardsPageComponent } from '@uigy/shared/modules/grid/grid-pages/cards-page/cards-page.component';
import { LanguageService } from '@uigy/shared/services/language.service';
import { HeadingComponent } from '@uigy/shared/components/heading/heading.component';
import { AppIdsEnum } from '@uigy/shared/directives/app-id/appIds.enum';
import { HOST_ATTR_APP_ID } from '@uigy/shared/directives/app-id/host-attributes.constant';
import { I18NextModule } from 'angular-i18next';
import {
  OtdScanFileUploadComponent
} from '@uigy/modules/settings/modules/data-sources/otd-scan-file-upload/otd-scan-file-upload.component';

@Component({
  selector: 'app-data-sources-tabs',
  imports: [
    HeadingComponent,
    MaterialModule,
    I18NextModule,
    NessusScansModule,
    IotConnectorsModule,
    SensorsModule,
    PcapPlayerModule,
    AssetsSettingsModule,
    OtAgentsComponent,
    ProjectFilesComponent,
    CardsPageComponent,
    TabsComponent,
    OtdScanFileUploadComponent,
  ],
  templateUrl: './data-sources.component.html',
  styleUrl: './data-sources.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataSourcesComponent implements OnInit {
  public readonly languageService = inject(LanguageService);
  public readonly texts = this.languageService.texts;

  public tabs: Tab[] = [];
  @ViewChild('sensors', { static: true }) sensors?: TemplateRef<SensorsComponent>;
  @ViewChild('otAgents', { static: true }) otAgents?: TemplateRef<OtAgentsComponent>;
  @ViewChild('iotConnectors', { static: true }) iotConnectors?: TemplateRef<IotConnectorsComponent>;
  @ViewChild('pcap', { static: true }) pcap?: TemplateRef<PcapPlayerComponent>;
  @ViewChild('uploads', { static: true }) uploads?: TemplateRef<any>;

  @HostBinding(HOST_ATTR_APP_ID)
  public readonly hostAppId: string = AppIdsEnum.page_data_sources;

  public readonly tabConfig: TabConfig = {
    tabId: TabGroup.DataSources,
  };


  public ngOnInit(): void {

    if (this.sensors && this.iotConnectors && this.pcap && this.uploads && this.otAgents) {
      this.tabs = [
        {
          appId: AppIdsEnum.sensors_tab,
          title: this.texts.settings.system_config.sensors.title,
          content: this.sensors,
          queryParams: DataSourceTabQueryParams.Sensors,
          capability: Capability.ReadSensors,
        },
        {
          appId: AppIdsEnum.agents_tab,
          title: this.texts.ot_agents.title,
          content: this.otAgents,
          queryParams: DataSourceTabQueryParams.OTAgents,
          capability: Capability.ReadOtAgents,
        },
        {
          appId: AppIdsEnum.iot_tab,
          title: this.texts.settings.iot_connectors.title,
          content: this.iotConnectors,
          queryParams: DataSourceTabQueryParams.IotConnectors,
          capability: Capability.IotConnectors,
        },
        {
          appId: AppIdsEnum.pcap_tab,
          title: this.texts.settings.env_config.pcap_player.title,
          content: this.pcap,
          queryParams: DataSourceTabQueryParams.PCAPPlayer,
          capability: Capability.PcapPlayer,
        },
        {
          appId: AppIdsEnum.manual_upload_tab,
          title: this.texts.settings.data_collection.data_sources.manual_uploads.title,
          content: this.uploads,
          queryParams: DataSourceTabQueryParams.ManualUploads,
          capability: Capability.WriteAssets,
        },
      ];
    }
  }
}
